import { useQuery } from '@tanstack/react-query';
import { getAdminStatus, type AdminStatus } from '../api/admin';

/** Hook to fetch the Admin page's data (`GET /api/v1/admin`). */
export function useAdminStatus() {
  return useQuery<AdminStatus>({
    queryKey: ['admin'],
    queryFn: getAdminStatus,
    retry: false,
  });
}
